import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getSupplierCatalogs, SupplierCatalogsResponse, SupplierCatalogQueryParams } from '@v2/network/SecretShopAPI';

export const GET_SUPPLIER_CATALOG = 'GET_SUPPLIER_CATALOG';

export const useGetSupplierCatalogs = (params:SupplierCatalogQueryParams): UseQueryResult<SupplierCatalogsResponse> => useQuery([GET_SUPPLIER_CATALOG, params.supplierUrlsafeKey], () => getSupplierCatalogs(params), { enabled: !!params.supplierUrlsafeKey, });
